

define(['angular', 'squid/index', './model'], function (angular) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('tracking.builder', ['squid', 'tracking.model']).factory('$FptiBuilder', function ($Class, $locale, $rootScope, $FptiConstants, $FptiDataModel, $CalDataModel, $util) {
        /**
         *  Build the front-end FPTI event from three data sources
         *      1. the per-product configuration
         *      2. the buzname defined per-route
         *      3. the additional attributes that only available at a specific checkpoint
         *
         */

        return $Class.extend('FptiBuilder', {

            resolvePageQualifier: function resolvePageQualifier(trackingData) {
                // The pages can populated pageQualifier to override the default one
                this.pageQualifier = trackingData && trackingData.pageQualifier ? trackingData.pageQualifier
                // because 'fullpage' has been widely embedded into routes
                // we had better to keep it as a place holder
                : 'fullpage'; // update later if it's in-context
            },

            build: function build() {

                if (!this.trackingData && !this.error) {
                    // do nothing if neither page nor error tracking
                    return this;
                }

                this.resolvePageQualifier(this.trackingData);

                this._dataObj = new $FptiDataModel().decorate('buzname', this.trackingData, this.pageQualifier).decorate('templateName', this.trackingData, this.pageQualifier).decorate('locale', $locale).decorate('pageGoal', this.trackingData.pageGoal).decorate('ecToken', this.trackingData.token).decorate('correlationId', $CalDataModel.getCalCorrId()).decorate('uuid', $CalDataModel.getUUID()).decorate('fieldError', this.error).decorate('pageError', this.error).decorate('pageStartTime', new Date().getTime()).decorate('pxptrackingdata', this.trackingData.pxpData).decorate('pxpguid', window.meta.userGuid).decorate('transition_time', this.transition_time).decorate('cust', this.cust).decorate('dc', this.dc).decorate('az', this.az).getDataObject(this.isInContext);

                return this;
            },

            toString: function toString() {

                var dataAry = [];
                angular.forEach(this._dataObj, function (v, k) {
                    dataAry.push(k + '=' + v);
                });

                return dataAry.join('&');
            }
        });
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-tracking/dist/builder.js
 ** module id = 168
 ** module chunks = 1
 **/